import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils";

const baseUrl = "/api/dog/testna_postaja/odkup";

export const addAnimalToPurchase = createAsyncThunk(
  "/purchase/addAnimalToPurchase",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await ApiClient.post(`${baseUrl}/zival`, payload);

      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const addAnimalsToPurchaseBulk = createAsyncThunk(
  "/purchase/addAnimalsToPurchaseBulk",
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    try {
      const results = await Promise.allSettled(
        payload.map((animal) => dispatch(addAnimalToPurchase(animal)).unwrap())
      );

      const succeeded = [];
      const failed = [];

      results.forEach((result, index) => {
        if (result.status === "fulfilled") {
          succeeded.push(result.value);
        } else {
          failed.push({
            animal: payload[index],
            error: getErrorMessage(result.reason),
          });
        }
      });

      return { succeeded, failed, total: payload.length };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const createPurchase = createAsyncThunk(
  "/purchase/purchase",
  async (payload, { rejectWithValue, fulfillWithValue }) => {
    try {
      const res = await ApiClient.post(`${baseUrl}/odkup`, payload);

      return res.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

// Slice
const purchaseSlice = createSlice({
  name: "purchase",
  initialState: {
    create: { isLoading: false, error: null, last: null },
    candidates: { isLoading: false, error: null, data: [] },
  },
  reducers: {
    resetPurchase: (state) => {
      state.create = { isLoading: false, error: null, last: null };
      state.candidates = { isLoading: false, error: null, data: [] };
    },
  },
  extraReducers: (builder) => {
    builder
      // Create animal to purchase
      .addCase(addAnimalToPurchase.pending, (state) => {
        state.candidates.isLoading = true;
        state.candidates.error = null;
      })
      .addCase(addAnimalToPurchase.fulfilled, (state, action) => {
        state.candidates.isLoading = false;
        state.candidates.data.push(action.payload);
      })
      .addCase(addAnimalToPurchase.rejected, (state, action) => {
        state.candidates.isLoading = false;
        state.candidates.error = action.payload ?? action.error;
      })
      // Create animals to purchase bulk
      .addCase(addAnimalsToPurchaseBulk.pending, (state) => {
        state.create.isLoading = true;
        state.create.error = null;
      })
      .addCase(addAnimalsToPurchaseBulk.rejected, (state, action) => {
        state.create.isLoading = false;
        state.create.error = action.payload ?? action.error;
      })
      .addCase(addAnimalsToPurchaseBulk.fulfilled, (state, action) => {
        state.create.isLoading = false;
        state.create.error = null;
        state.create.last = action.payload;
      })
      // createPurchase
      .addCase(createPurchase.pending, (state) => {
        state.create.isLoading = true;
        state.create.error = null;
        state.create.last = null;
      })
      .addCase(createPurchase.fulfilled, (state, action) => {
        state.create.isLoading = false;
        state.create.last = action.payload;
      })
      .addCase(createPurchase.rejected, (state, action) => {
        state.create.isLoading = false;
        state.create.error = action.payload ?? action.error;
      });
  },
});

export const { resetPurchase } = purchaseSlice.actions;
export default purchaseSlice.reducer;
